// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import { IHttpResponse } from 'app_types/httpTypes'
import {IAllianceBrochureParams, ILanding, ILandingTutorialParamsUpdateMany, IParamsGetLandingData, IParamsUpdateForumsLanding} from 'app_types/admin/landings/landingTypes'
import { IAllianceBrochure } from '../../../types/admin/landings/landingTypes';
import { IRoleListItem } from 'app_types/admin/role/roleTypes'
// @end

class LandingService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  private typeAgreementList = [
    { value: 'alliance', label: `Alianza` },
    { value: 'agreement', label: `Convenio` },
  ]

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  get getTypeAgreementList () {
    return this.typeAgreementList
  }

  getTypeAgreementLabel = (value: string | undefined) => {
    return this.typeAgreementList.filter((i) => i.value === value)[0].label || null
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  fetchLandingData = async (params: IParamsGetLandingData) => {
    this.refreshAuthToken()

    let responseData: ILanding

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/landing/fetch-landing/${params.slug}`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  saveGeneralInfo = async (saveData: any, action: string = 'create') => {
    this.refreshAuthToken()

    let responseData: ILanding

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/landing/${action}`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
      }),
      auth_token: this.token,
      params: saveData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.landing
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  saveArticle = async (saveData: any) => {
    this.refreshAuthToken()

    let responseData: ILanding

    const formData = new FormData()

    Object.keys(saveData).map((key: string) => {
      if (typeof saveData[key] === 'object' && !!saveData[key][0]?.name && !!saveData[key][0].type) {
        formData.append(key, saveData[key][0])
      } else if (typeof saveData[key] === 'object' && !(saveData[key] instanceof Array)) {
        formData.append(key, JSON.stringify(saveData[key]))
      } else {
        formData.append(key, saveData[key])
      }
      return true
    })

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/landing/insert-or-update-article`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.landing
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  saveTermsAndConditions = async (saveData: any) => {
    this.refreshAuthToken()

    let responseData: ILanding

    const formData = new FormData()

    // Procesar cada clave del objeto saveData
    Object.keys(saveData).forEach((key: string) => {
      const value = saveData[key];

      // Si es un objeto complejo (no File, no Array), convertirlo a JSON string
      if (typeof value === 'object' && value !== null && !(value instanceof File) && !(value instanceof Array)) {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    });

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/landing/insert-or-update-terms-and-conditions`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.landing
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  saveDescriptiveTraining = async (saveData: any) => {
    this.refreshAuthToken()

    let responseData: ILanding

    const formData = new FormData()

    Object.keys(saveData).map((key: string) => {
      if (typeof saveData[key] === 'object' && !!saveData[key][0]?.name && !!saveData[key][0].type) {
        formData.append(key, saveData[key][0])
      } else if (typeof saveData[key] === 'object' && !(saveData[key] instanceof Array)) {
        formData.append(key, JSON.stringify(saveData[key]))
      } else {
        formData.append(key, saveData[key])
      }
      return true
    })

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/landing/insert-or-update-descriptive-training`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.landing
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  saveAlliance = async (saveData: any) => {
    this.refreshAuthToken()

    let responseData: ILanding

    const formData = new FormData()

    Object.keys(saveData).map((key: string) => {
      if (typeof saveData[key] === 'object' && !!saveData[key][0]?.name && !!saveData[key][0].type) {
        formData.append(key, saveData[key][0])
      } else if (typeof saveData[key] === 'object' && !(saveData[key] instanceof Array)) {
        formData.append(key, JSON.stringify(saveData[key]))
      } else {
        formData.append(key, saveData[key])
      }
      return true
    })

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/landing/insert-or-update-alliance`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.landing
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  saveAllianceBrochure = async ({ slug, allianceUnique, brochures }: IAllianceBrochureParams) => {
    this.refreshAuthToken()

    let responseData: ILanding

    const formData = new FormData()

    formData.append('slug', slug)
    formData.append('allianceUnique', allianceUnique)
    const brochuresToSend: IAllianceBrochure[] = []
    for(const brochure of brochures) {
      brochuresToSend.push({
        file: brochure.file,
        name: brochure.name,
        unique: brochure.unique,
      })
      if (brochure.fileToUpload) {
        formData.append(`${brochure.unique}__fileToUpload`, brochure.fileToUpload)
      }
    }
    formData.append('brochures', JSON.stringify(brochuresToSend))

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/landing/save-alliance-brochure`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.landing
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  removeAlliance = async (slug: string, unique: string) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'DELETE',
      url: `/api/admin/landing/delete-alliance/${slug}/${unique}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return true
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  saveTraining = async (saveData: any) => {
    this.refreshAuthToken()

    let responseData: ILanding

    const formData = new FormData()

    Object.keys(saveData).map((key: string) => {
      if (typeof saveData[key] === 'object' && !!saveData[key][0]?.name && !!saveData[key][0].type) {
        formData.append(key, saveData[key][0])
      } else if (typeof saveData[key] === 'object' && !(saveData[key] instanceof Array)) {
        formData.append(key, JSON.stringify(saveData[key]))
      } else {
        formData.append(key, saveData[key])
      }
      return true
    })

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/landing/insert-or-update-training`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.landing
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  removeTraining = async (slug: string, unique: string) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'DELETE',
      url: `/api/admin/landing/delete-training/${slug}/${unique}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return true
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  saveScheduling = async (saveData: any) => {
    this.refreshAuthToken()

    let responseData: ILanding

    const formData = new FormData()

    Object.keys(saveData).map((key: string) => {
      if (typeof saveData[key] === 'object' && !!saveData[key][0]?.name && !!saveData[key][0].type) {
        formData.append(key, saveData[key][0])
      } else if (typeof saveData[key] === 'object' && !(saveData[key] instanceof Array)) {
        formData.append(key, JSON.stringify(saveData[key]))
      } else {
        formData.append(key, saveData[key])
      }
      return true
    })

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/landing/insert-or-update-scheduling`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.landing
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  removeScheduling = async (slug: string, unique: string) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'DELETE',
      url: `/api/admin/landing/delete-scheduling/${slug}/${unique}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return true
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  saveOurClient = async (saveData: any) => {
    this.refreshAuthToken()

    let responseData: ILanding

    const formData = new FormData()

    Object.keys(saveData).map((key: string) => {
      if (typeof saveData[key] === 'object' && !!saveData[key][0]?.name && !!saveData[key][0].type) {
        formData.append(key, saveData[key][0])
      } else if (typeof saveData[key] === 'object' && !(saveData[key] instanceof Array)) {
        formData.append(key, JSON.stringify(saveData[key]))
      } else {
        formData.append(key, saveData[key])
      }
      return true
    })

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/landing/insert-or-update-our-clients`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.landing
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  saveReference = async (saveData: any) => {
    this.refreshAuthToken()

    let responseData: ILanding

    const formData = new FormData()

    Object.keys(saveData).map((key: string) => {
      if (typeof saveData[key] === 'object' && !!saveData[key][0]?.name && !!saveData[key][0].type) {
        formData.append(key, saveData[key][0])
      } else if (typeof saveData[key] === 'object' && !(saveData[key] instanceof Array)) {
        formData.append(key, JSON.stringify(saveData[key]))
      } else {
        formData.append(key, saveData[key])
      }
      return true
    })

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/landing/insert-or-update-reference`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.landing
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  removeOurClient = async (slug: string, unique: string) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'DELETE',
      url: `/api/admin/landing/delete-our-client/${slug}/${unique}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return true
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  removeReference = async (slug: string, unique: string) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'DELETE',
      url: `/api/admin/landing/delete-reference/${slug}/${unique}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return true
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  saveForums = async (params: IParamsUpdateForumsLanding) => {
    this.refreshAuthToken()

    const saveData: any = params
    let responseData: ILanding

    const formData = new FormData()

    Object.keys(saveData).map((key: string) => {
      if (typeof saveData[key] === 'object' && !!saveData[key][0]?.name && !!saveData[key][0].type) {
        formData.append(key, saveData[key][0])
      } else if (typeof saveData[key] === 'object' && !(saveData[key] instanceof Array)) {
        formData.append(key, JSON.stringify(saveData[key]))
      } else {
        formData.append(key, saveData[key])
      }
      return true
    })

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/landing/insert-or-update-forums`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.landing
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  saveTutorial = async (saveData: any) => {
    this.refreshAuthToken()

    let responseData: ILanding

    const formData = new FormData()

    Object.keys(saveData).map((key: string) => {
      if (typeof saveData[key] === 'object' && !!saveData[key][0]?.name && !!saveData[key][0].type) {
        formData.append(key, saveData[key][0])
      } else if (typeof saveData[key] === 'object' && !(saveData[key] instanceof Array)) {
        formData.append(key, JSON.stringify(saveData[key]))
      } else {
        formData.append(key, saveData[key])
      }
      return true
    })

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/landing/insert-or-update-tutorial`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.landing
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  updateTutorialPositions = async ({ tutorials, slug }: ILandingTutorialParamsUpdateMany) => {
    if (tutorials?.length) {
      // TODO: Change this implementation to use Promise.all(...)
      for (const tutorial of tutorials) {
        await this.saveTutorial({
          unique: tutorial.unique,
          position: tutorial.position,
          slug,
        })
      }
    }
  }

  removeTutorial = async (slug: string, unique: string) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'DELETE',
      url: `/api/admin/landing/delete-tutorial/${slug}/${unique}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return true
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }
}

export default LandingService
